import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { resetloginState } from '../redux/loginSlice';
import { API_URL } from '../constants';

const ProtectedRoute = ({ children }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = useSelector((state) => state.login.data.token);
  const [isValidating, setIsValidating] = useState(true);
  const [isValid, setIsValid] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const validateToken = async () => {
      if (!token) {
        setIsValidating(false);
        setIsValid(false);
        return;
      }

      try {
        const response = await fetch(`${API_URL}/api/v1/profile`, {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        });

        if (response.ok) {
          setIsValid(true);
        } else {
          // Handle specific HTTP status codes if needed
          if (response.status === 401 || response.status === 403) {
            setIsValid(false);
            dispatch(resetloginState());
          } else {
            dispatch(resetloginState());
            setIsValid(false);
            setError('Server is down or unreachable. Please try again later.');
          }
        }
      } catch (error) {
        console.error('Token validation failed:', error);
        setIsValid(false);
        dispatch(resetloginState());

        setError('Unable to connect to the server. Please check your connection or try again later.');
        // Optionally avoid resetting token here
        // dispatch(resetloginState());
      } finally {
        setIsValidating(false);
      }
    };

    validateToken();
  }, [token, dispatch]);

  // Show loading state while validating
  if (isValidating) {
    return <div>Loading...</div>; // Replace with your loading component
  }

  // Redirect to login if no token or token is invalid
  if (!token || !isValid) {
    navigate('/login');
    // , { state: { reason: error || 'Invalid or missing token' } }
    return null;
  }

  // Render children if token is valid
  return children;
};

export default ProtectedRoute;